import React from 'react';
import MultiSelectCheckboxDropdown from '../MultiSelectCheckboxDropdown';
import MultiSelectCheckbox from '../MultiSelectCheckbox';
import styles from './PayOnlineStateFilter.scss';

const PayOnlineStateFilter = ({
  options,
  onSelect,
  selectedOptions,
  isMobileScreen,
  shouldResetStateFilter,
}) => {
  const allOptions = options.map((name, index) => ({ name, id: index }));
  const selectedOptionObjects = selectedOptions.map((name, index) => ({ name, id: index }));

  const handleSelect = (selectedList) => {
    const selectedListNames = selectedList.map(list => list.name);
    onSelect(selectedListNames);
  };

  return (
    <>
      {isMobileScreen
        ? (
          <div>
            <MultiSelectCheckbox
              options={allOptions}
              selectedList={selectedOptionObjects}
              onSelect={handleSelect}
              classes={styles.stateCheckbox}
              description="State"
            />
          </div>
        ) : (
          <MultiSelectCheckboxDropdown
            options={options}
            selectedList={selectedOptionObjects}
            onSelect={onSelect}
            shouldResetStateFilter={shouldResetStateFilter}
          />
        )}

    </>
  );
};

export default PayOnlineStateFilter;
